export default "<p class=\"access-denied\">{{ 'login.accessDenied' | translate }}</p>\n";